<!--特殊版 大图+双标题+第一行小字 -->
<template>
	<div>

		<div class="specialfirstimagetextview "
			style="position:absolute;  z-index: 90; "
			:style="titlestyle">
			<div style="display: flex; align-items:center">
				<div   class="specialfontsize1"  style="font-family: YouSheBiaoTiHei;">
					{{title}} </div>
				<div class="specialsubfontsize1" style=" margin-left: 25px; "> {{subtitle}}</div>
				<div class="specialsubfontsize1"  style=" margin-left: -350px; margin-top: 20px; opacity: 0.2;">
					{{subtitle}}</div>
			</div>
			<div v-if="title2"
				 class="specialfontsize1"  style="margin-top: -15px; font-family: YouSheBiaoTiHei;">
				{{title2}}
			</div>



			<button v-if="button"
				style="margin-right:42px ; font-size: 13px; border: 1px solid #FFFFFF;color: #FFFFFF; margin-top: 25px;line-height: 32px;  width: 80px; height: 32px;rgba(255, 255, 255, 0.2);"
				v-bind:style="styleObjectbutton">
				服务咨询
			</button>

			<slot></slot>
		</div>

		<img class=" firstimage"   :src="imgobj"  @load="onimagesize">

		</img>

	</div>
</template>

<script>
	export default {
		name: 'firstsceen',
		props: ['imgobj', "title", "title2", "subtitle", "button", "stylemode"],
		data() {
			return {
				titlestyle: {
					color: 'black',
				},
				styleObjectbutton: {
					background: 'rgba(255, 255, 255, 0.2)',
					opacity: 1,

				},
			}
		},
		methods: {
	onimagesize: function(e) {

				var height = e.path[0].clientHeight
				this.titlestyle.height = height
			}

		},

		mounted() {
			if (this.stylemode == 'blue') {
				this.titlestyle.color = "#263E8B"

			} else if (this.stylemode == 'white') {
				this.titlestyle.color = "white"

			}

			if (this.button == "blue") {
				this.styleObjectbutton.background = '#263E8B'
				this.styleObjectbutton.borderColor = '#263E8B'
				this.styleObjectbutton.border = '1 px solid #263E8B'
			}

		}

	}
</script>


<style>
	.video {
		position: absolute;
		width: 100%;
		margin-bottom: auto;
		height: auto;
		/* width: auto;   */
		/*加滤镜*/
		/* filter: blur(1px); //背景模糊设置 */
		/*-webkit-filter: grayscale(100%);*/
		/*filter:grayscale(100%); //背景灰度设置*/
		z-index: -11;
		object-fit: fill;
	}
	.firstimage {
		/* position: absolute; */
		width: 100%;
		margin-bottom: auto;
		/* height: auto; */
		/* width: auto;   */
		/*加滤镜*/
		/* filter: blur(1px); //背景模糊设置 */
		/*-webkit-filter: grayscale(100%);*/
		/*filter:grayscale(100%); //背景灰度设置*/
		z-index: -11;
		object-fit: fill;
	}

	@media (min-width: 1px) {
		.specialfontsize1 {
			font-size: 25px;
			letter-spacing: 5px;

		}
		.specialsubfontsize1{
			font-size: 12px;
			letter-spacing: 3px;
		}

		.specialfirstimagetextview {
			margin-top: 50px;
			left: 50px;
		}
	}

	@media (min-width: 1000px) {
		.specialfontsize1 {
			font-size: 100px;
			letter-spacing: 5px;

		}
		.specialsubfontsize1{
			font-size: 20px; 
			letter-spacing: 7px;
		}

		.specialfirstimagetextview {
			margin-top: 200px;
			left: 200px;
			 
		}
	}

	.fade-enter-active {
		transition: all 1.5s;
	}

	.fade-enter {
		opacity: 0;
		transform: translateY(-130px);
	}

	.fade2-enter-active {
		transition: all 1.5s;
	}

	.fade2-enter {
		opacity: 0;
		transform: translateY(130px);
	}
</style>
